import { createBrowserRouter } from 'react-router-dom';
import AdminLayout from './Admin';
import { Dashboard } from './components/Dashboard';
import { Pulse } from './components/Pulse';
import { PulseDetail } from './components/PulseDetail';
import { AppProvider } from './contexts';
import Auth from './pages/Auth';
import AuthError from './pages/Auth/Error';
import HomePage from './pages/Home';
import OnboardingPage from './pages/Onboarding';
import OnboardingSuccessPage from './pages/OnboardingSuccess';
import SkillPage from './pages/Skill';

export const router = createBrowserRouter([

    // 静态页面 - 不需要 Provider，避免触发接口调用
    {
        path: '/integrations/success',
        element: <OnboardingSuccessPage />
    },

    {
        path: '/',
        element: <AppProvider />,
        children: [
            {
                path: '/auth',
                element: <Auth />
            },
            {
                path: '/auth/error',
                element: <AuthError />
            },
            {
                path: '/onboarding',
                element: <OnboardingPage />
            },
            {
                element: <AdminLayout />,
                children: [
                    {
                        index: true,
                        element: <HomePage />
                    },
                    {
                        path: '/dashboard',
                        element: <Dashboard />
                    },
                    {
                        path: 'pulse',
                        element: <Pulse />
                    },
                    {
                        path: 'pulse/:pulseId',
                        element: <PulseDetail />
                    },
                    {
                        path: 'skill',
                        element: <SkillPage />
                    }
                ]
            }
        ]
    }
], {basename: '/admin'});